import { render, staticRenderFns } from "./cardholder-agreement.vue?vue&type=template&id=965012a8&scoped=true"
import script from "./cardholder-agreement.vue?vue&type=script&lang=js"
export * from "./cardholder-agreement.vue?vue&type=script&lang=js"
import style0 from "./cardholder-agreement.vue?vue&type=style&index=0&id=965012a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965012a8",
  null
  
)

export default component.exports